import React, { PureComponent } from 'react';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';

export default class UseMetricSelector extends PureComponent {
    state = {
        useMetric: this.props.useMetric | 0
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            useMetric: nextProps.useMetric | 0
        });
    }

    handleChange = event => {
        this.setState({ useMetric: event.target.value });
        this.props.onChange && this.props.onChange(event.target.value);
    };

    render() {
        return (
            <div>
                <Select
                    className="filter-bar-select"
                    value={this.state.useMetric}
                    onChange={this.handleChange}
                >
                    <MenuItem key="lb" value={0}>
                        LB
                    </MenuItem>
                    <MenuItem key="kg" value={1}>
                        KG
                    </MenuItem>
                </Select>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/common/UseMetricSelector.jsx